import ErrorHandler from '@module/error-handler';

export default {
  lookup(name) {
    let url = '';
    try {
      // in a deployed environment we need to resolve the assets from a CDN,
      // which can only be set at runtime by the ruby environment so we need this workaround
      const urlBase = window.asset_host || '';
      const pathFromManifest = require('images/' + name).default;
      if (pathFromManifest.startsWith(urlBase)) {
        // files from client-side
        url = pathFromManifest;
      } else {
        // files from server-side
        url = `${urlBase}${pathFromManifest}`;
      }
    } catch (e) {
      url = name;
      ErrorHandler.track(e);
    }
    return url;
  },
};
